import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { ClientePipeSharedModule } from '../../pipes/cliente-pipe-shared.module';

import { ClienteCentralCompraParticipanteComponent } from './cliente-central-compra-participante.component';

@NgModule({
    imports: [
        SharedModule,
        ClientePipeSharedModule
    ],
    declarations: [
        ClienteCentralCompraParticipanteComponent
    ],
    exports: [
        ClienteCentralCompraParticipanteComponent
    ]
})
export class ClienteCentralCompraParticipanteModule { }
